var _defs, _path, _path2, _path3, _path4, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMastero(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_782",
    "data-name": "Group 782",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 30,
    viewBox: "0 0 40 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_951",
    "data-name": "Rectangle 951",
    width: 40,
    height: 30,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_949",
    "data-name": "Rectangle 949",
    width: 5.161,
    height: 10.436,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_781",
    "data-name": "Group 781",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_780",
    "data-name": "Group 780"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_779",
    "data-name": "Group 779",
    clipPath: "url(#clip-path)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    d: "M5.036.5H34.714A4.565,4.565,0,0,1,39.25,5.092V24.658a4.565,4.565,0,0,1-4.536,4.592H5.036A4.565,4.565,0,0,1,.5,24.658V5.092A4.565,4.565,0,0,1,5.036.5",
    transform: "translate(0.125 0.125)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    d: "M5.036.5H34.714A4.565,4.565,0,0,1,39.25,5.092V24.658a4.565,4.565,0,0,1-4.536,4.592H5.036A4.565,4.565,0,0,1,.5,24.658V5.092A4.565,4.565,0,0,1,5.036.5Z",
    transform: "translate(0.125 0.125)",
    fill: "none",
    stroke: "#e6e6e6",
    strokeWidth: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_388",
    "data-name": "Path 388",
    d: "M14.193,19.826A6.522,6.522,0,1,0,7.742,13.3a6.486,6.486,0,0,0,6.451,6.521",
    transform: "translate(1.936 1.696)",
    fill: "#e7001a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    "data-name": "Path 389",
    d: "M20.387,19.826A6.522,6.522,0,1,0,13.936,13.3a6.486,6.486,0,0,0,6.451,6.521",
    transform: "translate(3.484 1.696)",
    fill: "#00a2e1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_778",
    "data-name": "Group 778",
    transform: "translate(17.419 9.782)",
    opacity: 0.3,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_777",
    "data-name": "Group 777"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_776",
    "data-name": "Group 776",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    d: "M16.516,7.826a6.565,6.565,0,0,1,0,10.436,6.565,6.565,0,0,1,0-10.436",
    transform: "translate(-13.936 -7.826)",
    fill: "#e7001a",
    fillRule: "evenodd"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastero);
export default __webpack_public_path__ + "static/media/mastero.e7471d83e071a397c48c7d70390d27c0.svg";
export { ForwardRef as ReactComponent };